import React from "react";
import PropTypes from "prop-types";

import Checkbox from "@material-ui/core/Checkbox";

const CustomCheckBox = (props) => {
  return (
    <>
      <Checkbox
        color="primary"
        {...props}
        inputProps={{ "aria-label": "primary checkbox" }}
      />
    </>
  );
};
CustomCheckBox.propTypes = {
  value: PropTypes.bool,
};

export default CustomCheckBox;
